import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, mergeProps as _mergeProps, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_chevron_sort_asc.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_chevron_sort_desc.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_chevron_sort.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1c939921")

_pushScopeId("data-v-1c939921")
const _hoisted_1 = { class: "flex justify-between items-end" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-14px self-center pt-4"
}
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = {
  key: 0,
  class: "w-full"
}
const _hoisted_8 = {
  key: 1,
  class: "ml-2 relative"
}
const _hoisted_9 = { class: "w-56" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row gap-4 mt-6"
}
const _hoisted_12 = { class: "text-black-lp-300" }
const _hoisted_13 = { class: "text-red-lp-300 font-semibold" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text-red-lp-300 font-semibold" }, "Download Form", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "ml-2 relative"
}
const _hoisted_17 = { class: "w-56" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 1,
  class: "ml-2 relative"
}
const _hoisted_20 = { class: "w-56" }
const _hoisted_21 = {
  key: 1,
  class: "ml-2 relative"
}
const _hoisted_22 = { class: "w-56" }
const _hoisted_23 = {
  key: 2,
  class: "text-red-lp-300 font-normal pl-1"
}
const _hoisted_24 = {
  key: 0,
  src: _imports_0
}
const _hoisted_25 = {
  key: 1,
  src: _imports_1
}
const _hoisted_26 = {
  key: 2,
  src: _imports_2
}
const _hoisted_27 = {
  key: 0,
  class: "bg-gray-lp-600 rounded",
  style: {"height":"20px","width":"20px"}
}
const _hoisted_28 = {
  key: 1,
  class: "rounded",
  style: {"height":"20px","width":"20px","background-color":"#FAB713"}
}
const _hoisted_29 = { class: "relative" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", {
  class: "arrow-left",
  style: {"border":"1px solid #E0E0E0","border-right":"none","border-bottom":"none","left":"-23px","top":"4px","width":"10px","height":"10px"}
}, null, -1)
const _hoisted_31 = {
  style: {"word-wrap":"break-word"},
  class: "whitespace-nowrap"
}
const _hoisted_32 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_33 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_34 = { class: "flex items-center max-w-full" }
const _hoisted_35 = {
  key: 1,
  class: "ml-1 relative"
}
const _hoisted_36 = { class: "flex flex-row" }
const _hoisted_37 = { class: "overflow-ellipsis text-left" }
const _hoisted_38 = { class: "flex flex-row" }
const _hoisted_39 = { class: "flex flex-col" }
const _hoisted_40 = {
  key: 1,
  class: "focus:outline-none "
}
const _hoisted_41 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M6 10c0 .53-.21 1.04-.586 1.414C5.04 11.79 4.53 12 4 12c-.53 0-1.04-.21-1.414-.586C2.21 11.04 2 10.53 2 10c0-.53.21-1.04.586-1.414C2.96 8.21 3.47 8 4 8c.53 0 1.04.21 1.414.586C5.79 8.96 6 9.47 6 10zm6 0c0 .53-.21 1.04-.586 1.414C11.04 11.79 10.53 12 10 12c-.53 0-1.04-.21-1.414-.586C8.21 11.04 8 10.53 8 10c0-.53.21-1.04.586-1.414C8.96 8.21 9.47 8 10 8c.53 0 1.04.21 1.414.586C11.79 8.96 12 9.47 12 10zm4 2c.53 0 1.04-.21 1.414-.586C17.79 11.04 18 10.53 18 10c0-.53-.21-1.04-.586-1.414C17.04 8.21 16.53 8 16 8c-.53 0-1.04.21-1.414.586C14.21 8.96 14 9.47 14 10c0 .53.21 1.04.586 1.414.375.375.884.586 1.414.586z"
  })
], -1)
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "text-12px" }
const _hoisted_44 = {
  key: 8,
  class: "flex gap-x-4"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "text-12px" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "text-12px" }
const _hoisted_53 = { class: "text-12px" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  key: 11,
  class: "flex flex-row"
}
const _hoisted_57 = {
  key: 0,
  class: " text-red-lp-300 text-16px bold mx-1"
}
const _hoisted_58 = { class: "text-12px" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  key: 0,
  id: "infinite-table-row"
}
const _hoisted_61 = /*#__PURE__*/_createVNode("td", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_MultipleSelectV3 = _resolveComponent("MultipleSelectV3")!
  const _component_MultipleSelectV2 = _resolveComponent("MultipleSelectV2")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_PaginationV3 = _resolveComponent("PaginationV3")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "top-left-table", {}, undefined, true),
      _createVNode("div", _hoisted_2, [
        (_ctx.isQuickSearch)
          ? (_openBlock(), _createBlock(_component_Search, {
              key: 0,
              class: "w-48",
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              placeholder: _ctx.$t('Cari')
            }, null, 8, ["onInput", "onClear", "value", "placeholder"]))
          : _createCommentVNode("", true),
        (_ctx.isSorting)
          ? (_openBlock(), _createBlock(_component_Select, {
              key: 1,
              class: "w-32",
              placeholder: _ctx.$t('Urutkan'),
              options: _ctx.sortingOptions,
              onSelect: _ctx.onSelectSorting,
              selectedItem: _ctx.selectedSorting,
              isCustomWidth: ""
            }, null, 8, ["placeholder", "options", "onSelect", "selectedItem"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.searchValue && _ctx.filteredDataBySearch.length && _ctx.isShowPagination)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t("Menampilkan")) + " ", 1),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.renderedList.length), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("data dari total")) + " ", 1),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.filteredDataBySearch.length), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("untuk")) + " ", 1),
          _createVNode("span", _hoisted_6, "“" + _toDisplayString(_ctx.searchValue) + "”", 1)
        ]))
      : _createCommentVNode("", true),
    ((!_ctx.renderedList.length || _ctx.errorCause) && !_ctx.loading && _ctx.isShowPagination)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (!_ctx.renderedList.length && _ctx.isHeaderEmptyActive.length)
            ? (_openBlock(), _createBlock("table", _hoisted_7, [
                _createVNode("thead", null, [
                  _createVNode("tr", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.isHeaderEmptyActive, (column, index) => {
                      return (_openBlock(), _createBlock("th", {
                        key: index,
                        id: `${_ctx.replaceWhiteSpaces(column.name)}-${index}`,
                        "data-testid": column.headerId || undefined,
                        style: 
              `${_ctx.isStickyHeader && 'position: sticky; top: 0;'} ${
                _ctx.isRightFreeze &&
                index >= _ctx.firstRowHeader.length - _ctx.totalColumnFreeze
                  ? 'position: sticky; ' +
                    _ctx.styleCustomRightFreeze(index, _ctx.firstRowHeader)
                  : ''
              }
                  ${_ctx.isLeftFreeze &&
                    index < _ctx.totalColumnFreeze &&
                    'position: sticky; left: 0;'}
                `
            ,
                        class: 
              `${_ctx.zIndexHeader} ${
                column.styleHead
              } text-base font-semibold text-black-lp-200 ${
                _ctx.isBorderOnHeadBgWhite ? 'border-t' : ''
              } ${
                column?.bgHeaderCell
                  ? 'bg-gray-lp-1900'
                  : _ctx.bgHeader || 'bg-gray-lp-700'
              } px-4 pt-5 ${
                index === 0 && !_ctx.isCheckBox ? 'rounded-tl-lg' : 'rounded-none'
              } ${
                index === _ctx.firstRowHeader.length - 1
                  ? 'rounded-tr-lg'
                  : 'rounded-none'
              }`
            ,
                        colspan: column.colSpan
                      }, [
                        _createVNode("div", {
                          class: 
                `${_ctx.headerTextColor ||
                  'text-black-lp-300'} flex flex-row justify-center`
              
                        }, [
                          (!column.hide)
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                _withDirectives(_createVNode("div", null, null, 512), [
                                  [_directive_sanitize_html, column.name]
                                ]),
                                (column.vtooltipHeader || column.onClickHeader)
                                  ? _withDirectives((_openBlock(), _createBlock("div", {
                                      key: 0,
                                      class: "cursor-pointer ml-2 text-12px text-black-lp-300",
                                      onClick: 
                    (event) => {
                      if (!!column.onClickHeader) {
                        column.onClickHeader(column, index);
                      }
                      event.stopPropagation();
                    }
                  
                                    }, [
                                      _createVNode(_component_Icons, {
                                        name: column.icon || _ctx.iconNameHeader,
                                        class: 
                      `w-5 ${
                        _ctx.toolTipHeaderStatus === column.name
                          ? 'text-red-lp-100'
                          : (column?.disableIconHeader &&
                              !!column?.disableIconHeader(column)) ||
                            !_ctx.headerTextColor
                          ? 'text-gray-lp-600'
                          : _ctx.headerTextColor
                      }`
                    
                                      }, null, 8, ["name", "class"])
                                    ], 8, ["onClick"])), [
                                      [
                                        _directive_tooltip,
                                        
                    column.vtooltipHeader &&
                      column.vtooltipHeader(column, index)
                  ,
                                        void 0,
                                        { top: true }
                                      ]
                                    ])
                                  : (column.tooltipHeader)
                                    ? (_openBlock(), _createBlock("div", _hoisted_8, [
                                        _createVNode("img", {
                                          onMouseenter: ($event: any) => (_ctx.toggleTooltipHeader($event, column.name)),
                                          onMouseleave: ($event: any) => (_ctx.toggleTooltipHeader($event, column.name)),
                                          alt: "",
                                          src: 
                      _ctx.toolTipHeaderStatus === column.name
                        ? require('@/app/ui/assets/svg/info-red.svg')
                        : require('@/app/ui/assets/svg/info.svg')
                    
                                        }, null, 40, ["onMouseenter", "onMouseleave", "src"]),
                                        (column.tooltipHeader)
                                          ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                              key: 0,
                                              ref: `opHeader${column.name}`,
                                              appendTo: "body"
                                            }, {
                                              default: _withId(() => [
                                                _withDirectives(_createVNode("div", _hoisted_9, null, 512), [
                                                  [_directive_sanitize_html, column.tooltipHeader()]
                                                ])
                                              ]),
                                              _: 2
                                            }, 1536))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 2)
                      ], 14, ["id", "data-testid", "colspan"]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.renderedList.length && _ctx.isEmpty && !_ctx.loading && !_ctx.isFilter)
            ? (_openBlock(), _createBlock(_component_EmptyState, {
                key: 1,
                icon: _ctx.iconEmpty,
                customHeaderMessage: _ctx.emptyHeaderMessage,
                customMessage: _ctx.emptyMessage
              }, null, 8, ["icon", "customHeaderMessage", "customMessage"]))
            : (_ctx.pagination.page === 1 && _ctx.searchValue === '')
              ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                  key: 2,
                  errorType: _ctx.errorCause || 'notfound',
                  onTryAgain: _ctx.isShowTryAgainBtn ? _ctx.onTryAgain : ''
                }, null, 8, ["errorType", "onTryAgain"]))
              : _createCommentVNode("", true),
          (
        _ctx.searchValue &&
          _ctx.filteredDataBySearch.length === 0 &&
          _ctx.pagination.page === 1
      )
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 3,
                class: "mb-4",
                "error-message": 
        _ctx.$t(`Maaf, data yang Anda cari tidak ditemukan.`, { searchValue: _ctx.searchValue })
      ,
                "error-title": _ctx.$t('Data tidak ditemukan'),
                "error-image": "data-not-found"
              }, null, 8, ["error-message", "error-title"]))
            : _createCommentVNode("", true),
          (_ctx.pagination.page !== 1)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 4,
                errorType: _ctx.errorCause || 'lastPage',
                onTryAgain: _ctx.isShowTryAgainBtn ? _ctx.onTryAgain : ''
              }, null, 8, ["errorType", "onTryAgain"]))
            : _createCommentVNode("", true),
          (_ctx.pagination.page > 1)
            ? (_openBlock(), _createBlock("div", {
                key: 5,
                class: _ctx.customClassPagination && _ctx.hiddenPagination
              }, [
                _createVNode(_component_Pagination, {
                  onNext: _ctx.nextPage,
                  onPrevious: _ctx.prevPage,
                  page: _ctx.pagination.page,
                  isButtonNext: _ctx.renderedList.length >= _ctx.pagination.limit,
                  totalData: _ctx.renderedList.length,
                  toPage: _ctx.toPage,
                  isShowCaption: _ctx.isShowCaptionPagination,
                  paginationWidth: _ctx.paginationWidth
                }, null, 8, ["onNext", "onPrevious", "page", "isButtonNext", "totalData", "toPage", "isShowCaption", "paginationWidth"])
              ], 2))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createBlock("div", {
          key: 2,
          class: 
      `${_ctx.borderTop && 'border-t'} ${_ctx.borderBottom &&
        'border-b'} ${!_ctx.isStickyHeader &&
        'overflow-y-auto'} border-gray-lp-200 relative ${!_ctx.isNoPaddingBottom &&
        'pb-18'}`
    
        }, [
          _createVNode("div", {
            id: "table-parent",
            class: ["overflow-auto flex flex-col table-freeze cursor-pointer", 
        `${_ctx.isPinnedScrollBottom &&
          ((_ctx.isRightFreeze && 'pinned-scroll-r-freeze') ||
            (_ctx.isLeftFreeze && 'pinned-scroll-l-freeze'))}`
      ],
            style: 
        `width: ${
          (_ctx.isLeftFreeze || _ctx.isRightFreeze) && !_ctx.isPinnedScrollBottom
            ? 100 - _ctx.totalPercentFreeze * _ctx.totalColumnFreeze
            : 100
        }%;
        ${(_ctx.isLeftFreeze || _ctx.isRightFreeze) &&
          _ctx.isPinnedScrollBottom &&
          `max-height: calc(calc(100vh / var(--viewport-scale)) - ${
            !_ctx.isTabList ? _ctx.pinnedSubstractHeight : '295px'
          });`}`
      ,
            onScrollPassive: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onScrollTableParent && _ctx.onScrollTableParent(...args)))
          }, [
            (_ctx.isCheckBox && _ctx.isDownloadCheckBox && _ctx.selectedCheckbox.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  (!_ctx.customContentHeadCheckbox)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode("p", _hoisted_12, _toDisplayString(_ctx.selectedCheckbox.length) + " Row" + _toDisplayString(_ctx.selectedCheckbox.length > 1 ? "s" : "") + " Selected ", 1),
                        _createVNode("span", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClearCheckbox && _ctx.onClearCheckbox(...args))),
                          class: "text-red-lp-300 font-semibold cursor-pointer"
                        }, "Clear"),
                        _createVNode("div", {
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDownloadResi && _ctx.onDownloadResi(...args))),
                          class: "flex flex-row gap-2 cursor-pointer"
                        }, [
                          _createVNode("img", {
                            src: require('@/app/ui/assets/svg/download.svg'),
                            alt: "download",
                            class: "w-5 max-w-none"
                          }, null, 8, ["src"]),
                          _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("downloadReceipt")), 1)
                        ]),
                        _createVNode("div", {
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDownloadForm && _ctx.onDownloadForm(...args))),
                          class: "flex flex-row gap-2 cursor-pointer"
                        }, [
                          _createVNode("img", {
                            src: require('@/app/ui/assets/svg/download.svg'),
                            alt: "download",
                            class: "w-5 max-w-none"
                          }, null, 8, ["src"]),
                          _hoisted_14
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "contentHeadCheckbox", {}, undefined, true),
            _createVNode("table", {
              id: "table-key",
              class: 
          `${
            _ctx.isCheckBox && _ctx.marginTopCheckbox
              ? 'mt-6'
              : _ctx.isSpaceTop
              ? 'mt-4 lg:mt-6 xl:mt-8'
              : ''
          } w-full ${(_ctx.isLeftFreeze || _ctx.isRightFreeze) &&
            'table-fixed'} ${_ctx.isSpaceBottom && 'mb-24'}`
        ,
              style: 
          `${((_ctx.isLeftFreeze || _ctx.isRightFreeze) &&
            _ctx.isPinnedScrollBottom &&
            `border-collapse: separate; border-spacing: 0;`) ||
            ''}`
        ,
              "aria-describedby": "data-table-genesis"
            }, [
              _createVNode("thead", null, [
                (_ctx.firstRowHeader.length)
                  ? (_openBlock(), _createBlock("tr", _hoisted_15, [
                      (_ctx.isCheckBox)
                        ? (_openBlock(), _createBlock("th", {
                            key: 0,
                            class: 
                `${_ctx.zIndexHeader} w-12 font-semibold ${_ctx.bgHeader ||
                  'bg-gray-lp-700'} text-12px xxl:text-14px px-4 py-2 lg:py-3 xl:py-4 rounded-tl-lg`
              ,
                            id: "header-checkboxes",
                            style: `${_ctx.isStickyHeader && 'position: sticky; top: 0;'}`
                          }, [
                            _createVNode(_component_Checkbox, {
                              name: "check-table-all",
                              modelValue: _ctx.isSelectAll,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSelectAll = $event)),
                              onClick: _ctx.onSelectAll,
                              binary: true,
                              disabled: !_ctx.filteredCheckboxLength > 0 || _ctx.loading
                            }, null, 8, ["modelValue", "onClick", "disabled"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.emitSelectedCheckbox), 1)
                          ], 6))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.firstRowHeader, (column, index) => {
                        return (_openBlock(), _createBlock("th", {
                          key: index,
                          id: `${_ctx.replaceWhiteSpaces(column.name)}-${index}`,
                          "data-testid": column.headerId || undefined,
                          style: 
                `${_ctx.isStickyHeader && 'position: sticky; top: 0;'} ${
                  _ctx.isRightFreeze &&
                  index >= _ctx.firstRowHeader.length - _ctx.totalColumnFreeze
                    ? 'position: sticky; ' +
                      _ctx.styleCustomRightFreeze(index, _ctx.firstRowHeader)
                    : ''
                }
                    ${_ctx.isLeftFreeze &&
                      index < _ctx.totalColumnFreeze &&
                      'position: sticky; left: 0;'}
                  `
              ,
                          class: 
                `${_ctx.zIndexHeader} ${
                  column.styleHead
                } text-base font-semibold text-black-lp-200 ${
                  _ctx.isBorderOnHeadBgWhite ? 'border-t' : ''
                } ${
                  column?.bgHeaderCell
                    ? 'bg-gray-lp-1900'
                    : _ctx.bgHeader || 'bg-gray-lp-700'
                } ${_ctx.compactDesign ? 'px-3' : 'px-4'} pt-5 ${
                  index === 0 && !_ctx.isCheckBox ? 'rounded-tl-lg' : 'rounded-none'
                } ${
                  index === _ctx.firstRowHeader.length - 1
                    ? 'rounded-tr-lg'
                    : 'rounded-none'
                }`
              ,
                          colspan: column.colSpan
                        }, [
                          _createVNode("div", {
                            class: 
                  `${_ctx.headerTextColor ||
                    'text-black-lp-300'} flex flex-row ${_ctx.firstRowHeaderAlignment}`
                
                          }, [
                            (!column.hide)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  _withDirectives(_createVNode("div", null, null, 512), [
                                    [_directive_sanitize_html, column.name]
                                  ]),
                                  (column.vtooltipHeader || column.onClickHeader)
                                    ? _withDirectives((_openBlock(), _createBlock("div", {
                                        key: 0,
                                        class: "cursor-pointer ml-2 text-12px text-black-lp-300",
                                        onClick: 
                      (event) => {
                        if (!!column.onClickHeader) {
                          column.onClickHeader(column, index);
                        }
                        event.stopPropagation();
                      }
                    
                                      }, [
                                        _createVNode(_component_Icons, {
                                          name: column.icon || _ctx.iconNameHeader,
                                          class: 
                        `w-5 ${
                          _ctx.toolTipHeaderStatus === column.name
                            ? 'text-red-lp-100'
                            : (column?.disableIconHeader &&
                                !!column?.disableIconHeader(column)) ||
                              !_ctx.headerTextColor
                            ? 'text-gray-lp-600'
                            : _ctx.headerTextColor
                        }`
                      
                                        }, null, 8, ["name", "class"])
                                      ], 8, ["onClick"])), [
                                        [
                                          _directive_tooltip,
                                          
                      column.vtooltipHeader &&
                        column.vtooltipHeader(column, index)
                    ,
                                          void 0,
                                          { top: true }
                                        ]
                                      ])
                                    : (column.tooltipHeader)
                                      ? (_openBlock(), _createBlock("div", _hoisted_16, [
                                          _createVNode("img", {
                                            onMouseenter: ($event: any) => (_ctx.toggleTooltipHeader($event, column.name)),
                                            onMouseleave: ($event: any) => (_ctx.toggleTooltipHeader($event, column.name)),
                                            alt: "",
                                            src: 
                        _ctx.toolTipHeaderStatus === column.name
                          ? require('@/app/ui/assets/svg/info-red.svg')
                          : require('@/app/ui/assets/svg/info.svg')
                      
                                          }, null, 40, ["onMouseenter", "onMouseleave", "src"]),
                                          (column.tooltipHeader)
                                            ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                                key: 0,
                                                ref: `opHeader${column.name}`,
                                                appendTo: "body"
                                              }, {
                                                default: _withId(() => [
                                                  _withDirectives(_createVNode("div", _hoisted_17, null, 512), [
                                                    [_directive_sanitize_html, column.tooltipHeader()]
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1536))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], 14, ["id", "data-testid", "colspan"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.secondRowHeader.length)
                  ? (_openBlock(), _createBlock("tr", _hoisted_18, [
                      (_ctx.isCheckBox)
                        ? (_openBlock(), _createBlock("th", {
                            key: 0,
                            class: 
                `${_ctx.zIndexHeader} w-12 font-semibold ${_ctx.bgHeader ||
                  'bg-gray-lp-700'} text-12px xxl:text-14px px-4 py-2 lg:py-3 xl:py-4 ${_ctx.roundedHeaderLeft ||
                  'rounded-l-lg'}`
              ,
                            id: "header-checkboxes",
                            style: `${_ctx.isStickyHeader && 'position: sticky; top: 0;'}`
                          }, [
                            _createVNode(_component_Checkbox, {
                              name: "check-table-all",
                              modelValue: _ctx.isSelectAll,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isSelectAll = $event)),
                              onClick: _ctx.onSelectAll,
                              binary: true,
                              disabled: !_ctx.filteredCheckboxLength > 0 || _ctx.loading
                            }, null, 8, ["modelValue", "onClick", "disabled"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.emitSelectedCheckbox), 1)
                          ], 6))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.secondRowHeader, (column, index) => {
                        return (_openBlock(), _createBlock("th", {
                          key: index,
                          id: `${_ctx.replaceWhiteSpaces(column.name)}-${index}`,
                          "data-testid": column.headerId || undefined,
                          style: 
                `${_ctx.isStickyHeader && 'position: sticky; top: 0;'} ${
                  _ctx.isRightFreeze &&
                  index >= _ctx.secondRowHeader.length - _ctx.totalColumnFreeze
                    ? 'position: sticky; ' +
                      _ctx.styleCustomRightFreeze(index, _ctx.secondRowHeader)
                    : ''
                }
                    ${_ctx.isLeftFreeze &&
                      index < _ctx.totalColumnFreeze &&
                      'position: sticky; left: 0;'}
                  `
              ,
                          class: 
                `${_ctx.zIndexHeader} ${
                  column.styleHead
                } text-base font-semibold text-black-lp-200 ${_ctx.bgHeader ||
                  'bg-gray-lp-700'} px-4 pt-5`
              ,
                          colspan: column.colSpan
                        }, [
                          _createVNode("div", {
                            class: 
                  `${_ctx.headerTextColor ||
                    'text-black-lp-300'} flex flex-row justify-center`
                
                          }, [
                            (!column.hide)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  _withDirectives(_createVNode("div", null, null, 512), [
                                    [_directive_sanitize_html, column.name]
                                  ]),
                                  (column.vtooltipHeader || column.onClickHeader)
                                    ? _withDirectives((_openBlock(), _createBlock("div", {
                                        key: 0,
                                        class: "cursor-pointer ml-2 text-12px text-black-lp-300",
                                        onClick: 
                      (event) => {
                        if (!!column.onClickHeader) {
                          column.onClickHeader(column, index);
                        }
                        event.stopPropagation();
                      }
                    
                                      }, [
                                        _createVNode(_component_Icons, {
                                          name: column.icon || _ctx.iconNameHeader,
                                          class: 
                        `w-5 ${
                          _ctx.toolTipHeaderStatus === column.name
                            ? 'text-red-lp-100'
                            : (column?.disableIconHeader &&
                                !!column?.disableIconHeader(column)) ||
                              !_ctx.headerTextColor
                            ? 'text-gray-lp-600'
                            : _ctx.headerTextColor
                        }`
                      
                                        }, null, 8, ["name", "class"])
                                      ], 8, ["onClick"])), [
                                        [
                                          _directive_tooltip,
                                          
                      column.vtooltipHeader &&
                        column.vtooltipHeader(column, index)
                    ,
                                          void 0,
                                          { top: true }
                                        ]
                                      ])
                                    : (column.tooltipHeader)
                                      ? (_openBlock(), _createBlock("div", _hoisted_19, [
                                          _createVNode("img", {
                                            onMouseenter: ($event: any) => (_ctx.toggleTooltipHeader($event, column.name)),
                                            onMouseleave: ($event: any) => (_ctx.toggleTooltipHeader($event, column.name)),
                                            alt: "",
                                            src: 
                        _ctx.toolTipHeaderStatus === column.name
                          ? require('@/app/ui/assets/svg/info-red.svg')
                          : require('@/app/ui/assets/svg/info.svg')
                      
                                          }, null, 40, ["onMouseenter", "onMouseleave", "src"]),
                                          (column.tooltipHeader)
                                            ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                                key: 0,
                                                ref: `opHeader${column.name}`,
                                                appendTo: "body"
                                              }, {
                                                default: _withId(() => [
                                                  _withDirectives(_createVNode("div", _hoisted_20, null, 512), [
                                                    [_directive_sanitize_html, column.tooltipHeader()]
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1536))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], 14, ["id", "data-testid", "colspan"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("tr", null, [
                  (_ctx.isCheckBox)
                    ? (_openBlock(), _createBlock("th", {
                        key: 0,
                        class: 
                `${_ctx.zIndexHeader} w-12 font-semibold ${_ctx.bgHeader ||
                  'bg-gray-lp-700'} text-12px xxl:text-14px px-4 py-2 lg:py-3 xl:py-4 rounded-l-lg`
              ,
                        id: "header-checkboxes",
                        style: `${_ctx.isStickyHeader && 'position: sticky; top: 0px;'}`
                      }, [
                        (!_ctx.isHideHeadCheckbox)
                          ? (_openBlock(), _createBlock(_component_Checkbox, {
                              key: 0,
                              name: "check-table-all",
                              modelValue: _ctx.isSelectAll,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isSelectAll = $event)),
                              onClick: _ctx.onSelectAll,
                              binary: true,
                              disabled: !_ctx.filteredCheckboxLength > 0 || _ctx.loading
                            }, null, 8, ["modelValue", "onClick", "disabled"]))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.emitSelectedCheckbox), 1)
                      ], 6))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
                    return (_openBlock(), _createBlock("th", {
                      key: index,
                      id: `${_ctx.replaceWhiteSpaces(column.name)}-${index}`,
                      "data-testid": column.headerId || undefined,
                      style: 
                `${
                  _ctx.isStickyHeader
                    ? _ctx.secondRowHeader.length
                      ? 'position: sticky; top: 63px;'
                      : 'position: sticky; top: 0px;'
                    : ''
                } ${
                  _ctx.isRightFreeze && index >= _ctx.columns.length - _ctx.totalColumnFreeze
                    ? 'position: sticky; ' +
                      _ctx.styleCustomRightFreeze(index, _ctx.columns)
                    : ''
                }
                  ${_ctx.isLeftFreeze &&
                    index < _ctx.totalColumnFreeze &&
                    'position: sticky; left: 0;'}
                `
              ,
                      class: 
                `${_ctx.zIndexHeader} ${
                  column.styleHead
                } text-base font-semibold text-black-lp-200 ${
                  _ctx.isBorderOnHeadBgWhite ? 'border-b' : ''
                } ${_ctx.bgHeader || 'bg-gray-lp-700'} ${
                  _ctx.compactDesign ? 'px-3' : 'px-4'
                } ${
                  _ctx.customColumnPaddingVertical
                    ? _ctx.customColumnPaddingVertical
                    : _ctx.secondRowHeader.length || _ctx.compactDesign
                    ? 'py-2 lg:py-3 xl:py-4'
                    : 'py-3 lg:py-4 xl:py-5'
                } ${index === 0 &&
                  !_ctx.isCheckBox &&
                  (_ctx.roundedHeaderLeft || 'rounded-l-lg')} ${index ===
                  _ctx.columns.length - 1 &&
                  (_ctx.roundedHeaderRight || 'rounded-r-lg')} ${
                  !!column?.bgHeaderCell ? 'bg-gray-lp-1900' : ''
                }`
              
                    }, [
                      _createVNode("div", {
                        class: 
                  `${_ctx.headerTextColor || 'text-black-lp-300'} ${
                    column.styleHead
                  } flex flex-row w-full`
                
                      }, [
                        (!column.hide)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _withDirectives(_createVNode("div", null, null, 512), [
                                [_directive_sanitize_html, column.name]
                              ]),
                              (column.vtooltipHeader || column.onClickHeader)
                                ? _withDirectives((_openBlock(), _createBlock("div", {
                                    key: 0,
                                    class: "cursor-pointer ml-2 text-12px text-black-lp-300",
                                    onClick: 
                      (event) => {
                        if (!!column.onClickHeader) {
                          column.onClickHeader(column, index);
                        }
                        event.stopPropagation();
                      }
                    
                                  }, [
                                    _createVNode(_component_Icons, {
                                      name: column.icon || _ctx.iconNameHeader,
                                      class: 
                        `w-5 ${
                          _ctx.toolTipHeaderStatus === column.name
                            ? 'text-red-lp-100'
                            : (column?.disableIconHeader &&
                                !!column?.disableIconHeader(column)) ||
                              !_ctx.headerTextColor
                            ? `${
                                _ctx.isBorderOnHeadBgWhite
                                  ? 'text-gray-lp-300'
                                  : 'text-gray-lp-600'
                              }`
                            : _ctx.headerTextColor
                        }`
                      
                                    }, null, 8, ["name", "class"])
                                  ], 8, ["onClick"])), [
                                    [
                                      _directive_tooltip,
                                      
                      column.vtooltipHeader &&
                        column.vtooltipHeader(column, index)
                    ,
                                      void 0,
                                      { top: true }
                                    ]
                                  ])
                                : (column.tooltipHeader)
                                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                                      _createVNode("img", {
                                        onMouseenter: ($event: any) => (_ctx.toggleTooltipHeader($event, column.name)),
                                        onMouseleave: ($event: any) => (_ctx.toggleTooltipHeader($event, column.name)),
                                        alt: "",
                                        src: 
                        _ctx.toolTipHeaderStatus === column.name
                          ? require('@/app/ui/assets/svg/info-red.svg')
                          : require('@/app/ui/assets/svg/info.svg')
                      
                                      }, null, 40, ["onMouseenter", "onMouseleave", "src"]),
                                      (column.tooltipHeader)
                                        ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                            key: 0,
                                            ref: `opHeader${column.name}`,
                                            appendTo: "body"
                                          }, {
                                            default: _withId(() => [
                                              _withDirectives(_createVNode("div", _hoisted_22, null, 512), [
                                                [_directive_sanitize_html, column.tooltipHeader()]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1536))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                              (column.asterisk)
                                ? (_openBlock(), _createBlock("span", _hoisted_23, "*"))
                                : _createCommentVNode("", true),
                              (column.sortBy)
                                ? (_openBlock(), _createBlock("button", {
                                    key: 3,
                                    class: "flex flex-row gap-2 px-2 py-1 ml-1",
                                    onClick: () => _ctx.onSort(column.sortBy)
                                  }, [
                                    (!_ctx.loading)
                                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                          (column.sortBy === _ctx.sortBy && _ctx.sortDirection === 'ASC')
                                            ? (_openBlock(), _createBlock("img", _hoisted_24))
                                            : (column.sortBy === _ctx.sortBy && _ctx.sortDirection === 'DESC')
                                              ? (_openBlock(), _createBlock("img", _hoisted_25))
                                              : (_openBlock(), _createBlock("img", _hoisted_26))
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 14, ["id", "data-testid"]))
                  }), 128))
                ])
              ]),
              _withDirectives(_createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.batchRender, (item, index) => {
                  return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                    _createVNode("tr", {
                      onClick: ($event: any) => (_ctx.isDetailAble ? _ctx.onClick(item) : () => {}),
                      class: 
                `${
                  _ctx.onHiglightData(index)
                    ? 'bg-aqua-lp-200'
                    : item[_ctx.keyRowColor]
                    ? _ctx.rowColor
                    : 'hover:bg-gray-lp-100'
                } ${_ctx.isDetailAble && 'cursor-pointer'}`
              ,
                      onMouseenter: ($event: any) => (_ctx.onHoverRow($event, index)),
                      onMouseleave: ($event: any) => (_ctx.onLeaveHoverRow($event, index))
                    }, [
                      (_ctx.ableToHoverPerRow)
                        ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                            key: 0,
                            ref: `hoverRow${index}`,
                            appendTo: "body"
                          }, {
                            default: _withId(() => [
                              _withDirectives(_createVNode("div", null, null, 512), [
                                [_directive_sanitize_html, _ctx.hoverTemplate(item, index)]
                              ])
                            ]),
                            _: 2
                          }, 1536))
                        : _createCommentVNode("", true),
                      (_ctx.isCheckBox)
                        ? (_openBlock(), _createBlock("td", {
                            key: 1,
                            onClick: _cache[8] || (_cache[8] = (event) => event.stopPropagation()),
                            class: 
                  `w-12 relative px-4 py-3 lg:py-4 xl:py-5 text-12px xxl:text-14px ${
                    item?.isCargo
                      ? 'checkbox-gray'
                      : item?.isAlreadyRTC
                      ? 'checkbox-red-transparent'
                      : ''
                  } ${_ctx.borderRowColor || 'border-gray-lp-400'} ${
                    index === _ctx.renderedList.length - 1
                      ? 'border-t border-b'
                      : index !== 0 && 'border-t'
                  }`
                ,
                            disabled: item?.isCargo
                          }, [
                            (_ctx.filteredCheckbox(item) && !_ctx.customModelCheckbox)
                              ? (_openBlock(), _createBlock(_component_Checkbox, {
                                  key: 0,
                                  name: `check-table-row${index}`,
                                  modelValue: _ctx.selectedCheckbox,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedCheckbox = $event)),
                                  value: item
                                }, null, 8, ["name", "modelValue", "value"]))
                              : (_ctx.customModelCheckbox)
                                ? (_openBlock(), _createBlock("div", {
                                    key: 1,
                                    class: "relative",
                                    onMouseenter: ($event: any) => (_ctx.onHoverCustomCheckbox($event, index, item)),
                                    onMouseleave: ($event: any) => (_ctx.onLeaveHoverCustomCheckbox($event, index))
                                  }, [
                                    (_ctx.onCheckCustomCheckbox(item) === 'grey')
                                      ? (_openBlock(), _createBlock("div", _hoisted_27, [
                                          _createVNode(_component_Icons, {
                                            name: "check",
                                            class: "text-white",
                                            style: {"width":"18px","height":"18px","padding-bottom":"2px","padding-left":"2.5px"}
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.onCheckCustomCheckbox(item) === 'yellow')
                                      ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                          _createVNode(_component_Icons, {
                                            name: "clock-v2",
                                            class: "text-white",
                                            style: {"width":"18px","height":"18px","padding-bottom":"2px","padding-left":"2.5px"}
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.onCheckCustomCheckbox(item) === 'red')
                                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                                          key: 2,
                                          onChange: ($event: any) => (_ctx.onUpdateReadyToDelete(item)),
                                          name: `check-table-row${index}`,
                                          modelValue: item.isAlreadyRTC,
                                          "onUpdate:modelValue": ($event: any) => (item.isAlreadyRTC = $event),
                                          binary: "",
                                          value: item
                                        }, null, 8, ["onChange", "name", "modelValue", "onUpdate:modelValue", "value"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.onCheckCustomCheckbox(item) === 'empty')
                                      ? (_openBlock(), _createBlock(_component_Checkbox, {
                                          key: 3,
                                          onChange: ($event: any) => (_ctx.onUpdateReadyToCargo(item)),
                                          name: `check-table-row${index}`,
                                          modelValue: item.isAbleRTC,
                                          "onUpdate:modelValue": ($event: any) => (item.isAbleRTC = $event),
                                          binary: "",
                                          value: item
                                        }, null, 8, ["onChange", "name", "modelValue", "onUpdate:modelValue", "value"]))
                                      : _createCommentVNode("", true),
                                    (
                      (_ctx.customModelCheckbox && !item.isAbleRTC) ||
                        item.isCargo ||
                        item.isRtcProcess
                    )
                                      ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                          key: 4,
                                          ref: `hoverCheckbox${index}`,
                                          appendTo: "body",
                                          class: 
                      `custom-overlay-default custom-overlay-${
                        _ctx.onCheckCustomCheckbox(item) != 'yellow'
                          ? 'grey'
                          : 'yellow'
                      }`
                    
                                        }, {
                                          default: _withId(() => [
                                            _createVNode("div", _hoisted_29, [
                                              _hoisted_30,
                                              _createVNode("p", {
                                                class: ["font-montserrat text-12px text-center", 
                          `${
                            _ctx.onCheckCustomCheckbox(item) == 'yellow'
                              ? 'text-chocolate-lp-300'
                              : 'text-black-lp-300'
                          }`
                        ]
                                              }, _toDisplayString(_ctx.messageTooltipCargo(item)), 3)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["class"]))
                                      : _createCommentVNode("", true)
                                  ], 40, ["onMouseenter", "onMouseleave"]))
                                : _createCommentVNode("", true)
                          ], 10, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, indexColumn) => {
                        return (_openBlock(), _createBlock("td", {
                          class: ["relative", 
                  `${column.styleCustom} ${
                    _ctx.compactDesign ? 'px-3 py-2' : 'px-4 py-3 lg:py-4 xl:py-5'
                  } text-12px xxl:text-14px ${_ctx.borderRowColor ||
                    'border-gray-lp-400'} ${
                    index === _ctx.renderedList.length - 1
                      ? 'border-t border-b'
                      : index !== 0 && 'border-t'
                  } ${_ctx.isLeftFreeze &&
                    indexColumn < _ctx.totalColumnFreeze &&
                    'absolute left-0 bg-white flex items-center'}
                  ${column.advancedStyle && column.advancedStyle(item)} ${
                    column?.bgRowCell && column?.bgRowCell(item)
                      ? 'bg-gray-lp-1900'
                      : ''
                  }`
                ],
                          key: indexColumn,
                          style: 
                  `${
                    _ctx.isRightFreeze &&
                    indexColumn >= _ctx.columns.length - _ctx.totalColumnFreeze
                      ? `position: sticky; background: ${
                          _ctx.onHiglightData(index) ? '#EAFCFF' : 'white'
                        };` + _ctx.styleCustomRightFreeze(indexColumn, _ctx.columns)
                      : ''
                  }
                  ${_ctx.isLeftFreeze &&
                    indexColumn < _ctx.totalColumnFreeze &&
                    'position: sticky; left: 0; background: white'}
                `
                
                        }, [
                          (column?.['custom-slot'])
                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                (_ctx.hasNamedSlot(column))
                                  ? _renderSlot(_ctx.$slots, _ctx.getSlotName(column), {
                                      key: 0,
                                      item: item,
                                      column: column
                                    }, undefined, true)
                                  : _renderSlot(_ctx.$slots, "custom-slot", {
                                      key: 1,
                                      item: item,
                                      column: column
                                    }, undefined, true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.toolTip)
                            ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                key: 1,
                                ref: `op${column.name}${index}`,
                                appendTo: "body"
                              }, {
                                default: _withId(() => [
                                  _withDirectives(_createVNode("div", _hoisted_31, null, 512), [
                                    [_directive_sanitize_html, column.toolTip(item, index)]
                                  ])
                                ]),
                                _: 2
                              }, 1536))
                            : _createCommentVNode("", true),
                          (column.key === 'input-cell')
                            ? (_openBlock(), _createBlock("div", _hoisted_32, [
                                _createVNode(_component_LpInput, column.render(item, index), null, 16)
                              ]))
                            : (
                    column.key === 'multiple-select-cell' ||
                      column.useMultipleSelectV3 === true
                  )
                              ? (_openBlock(), _createBlock("div", _hoisted_33, [
                                  (column.useMultipleSelectV3 === true)
                                    ? (_openBlock(), _createBlock(_component_MultipleSelectV3, _mergeProps({ key: 0 }, column.render(item, index)), null, 16))
                                    : (_openBlock(), _createBlock(_component_MultipleSelectV2, _mergeProps({ key: 1 }, column.render(item, index)), null, 16))
                                ]))
                              : (
                    column.key !== 'download_column' &&
                      column.key !== 'download_column_button' &&
                      column.key !== 'actionable_column' &&
                      column.key !== 'button_column' &&
                      column.key !== 'double_button_column'
                  )
                                ? (_openBlock(), _createBlock("div", {
                                    key: 4,
                                    class: `flex ${column.styleCustom} ${column.styleRender}`
                                  }, [
                                    _createVNode("div", _hoisted_34, [
                                      (column.putIcon)
                                        ? (_openBlock(), _createBlock(_component_Icons, {
                                            key: 0,
                                            name: column.putIcon(item).iconName,
                                            class: `pr-1 ${column.putIcon(item).style}`
                                          }, null, 8, ["name", "class"]))
                                        : _createCommentVNode("", true),
                                      _withDirectives(_createVNode("div", {
                                        onClick: 
                        (event) => {
                          if (
                            !!column?.onClickValue &&
                            !_ctx.isDisableClickValue(column, item, index)
                          ) {
                            column?.onClickValue(
                              item,
                              index,
                              column?.columnKey
                            );
                          }
                          event.stopPropagation();
                        }
                      ,
                                        onMouseenter: 
                        (event) => _ctx.onHoverValue(event, column, item, index)
                      ,
                                        onMouseleave: 
                        (event) => _ctx.onHoverValue(event, column, item, index)
                      ,
                                        class: 
                        `${
                          _ctx.isDisableClickValue(column, item, index)
                            ? 'cursor-not-allowed'
                            : !!column?.onClickValue &&
                              _ctx.columnNameActive === column.name &&
                              _ctx.isIndexActive === index
                            ? 'cursor-pointer'
                            : ''
                        } ${
                          !!column.isUnderline
                            ? 'hover:underline'
                            : 'no-underline'
                        } max-w-full`
                      ,
                                        style: 
                        !!column.isUnderline
                          ? 'text-decoration-color: #00875A;'
                          : ''
                      
                                      }, null, 46, ["onClick", "onMouseenter", "onMouseleave"]), [
                                        [_directive_sanitize_html, 
                        !!column.render && column.render(item, index)
                      ],
                                        [
                                          _directive_tooltip,
                                          
                        column.vtooltip ? column.vtooltip(item) : ''
                      ,
                                          void 0,
                                          { bottom: true }
                                        ]
                                      ]),
                                      (column.toolTip && column.toolTip(item, index))
                                        ? (_openBlock(), _createBlock("div", _hoisted_35, [
                                            (!column.hideIconTooltip)
                                              ? (_openBlock(), _createBlock("img", {
                                                  key: 0,
                                                  onMouseenter: ($event: any) => (_ctx.toggleInfoPanel($event, column, index)),
                                                  onMouseleave: ($event: any) => (_ctx.toggleInfoPanel($event, column, index)),
                                                  src: 
                          column.isEmbargo
                            ? require('@/app/ui/assets/svg/warning-red.svg')
                            : _ctx.toolTipStatus[column.name] === index
                            ? require('@/app/ui/assets/svg/info-red.svg')
                            : require('@/app/ui/assets/svg/info.svg')
                        ,
                                                  alt: "",
                                                  class: "w-20px max-w-none"
                                                }, null, 40, ["onMouseenter", "onMouseleave", "src"]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 2))
                                : (column.key === 'download_column')
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 5,
                                      class: `flex flex-col ${column.styleCustom}`
                                    }, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(column.downloadList(item, index), (list, index) => {
                                        return (_openBlock(), _createBlock("div", { key: index }, [
                                          _withDirectives(_createVNode("div", _hoisted_36, [
                                            _createVNode("div", _hoisted_37, _toDisplayString(list.name) + " : ", 1),
                                            _createVNode("div", {
                                              class: "text-red-lp-100 underline ml-2 cursor-pointer",
                                              onClick: 
                          (event) => {
                            _ctx.download(list.url, list.fileName);
                            event.stopPropagation();
                          }
                        
                                            }, _toDisplayString(list.fileName), 9, ["onClick"])
                                          ], 512), [
                                            [_vShow, list.fileName !== '']
                                          ])
                                        ]))
                                      }), 128))
                                    ], 2))
                                  : (column.key === 'download_column_button')
                                    ? (_openBlock(), _createBlock("div", {
                                        key: 6,
                                        class: `flex flex-col ${column.styleCustom}`
                                      }, [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(column.downloadList(item, index), (list, index) => {
                                          return (_openBlock(), _createBlock("div", { key: index }, [
                                            _createVNode(_component_lp_button, {
                                              title: list.title,
                                              textColor: list.textColor,
                                              flat: list.flat,
                                              iconLeft: list.icon,
                                              outline: list.outline,
                                              dense: list.flat,
                                              onClick: 
                        (event) => {
                          list.action();
                          event.stopPropagation();
                        }
                      
                                            }, null, 8, ["title", "textColor", "flat", "iconLeft", "outline", "dense", "onClick"])
                                          ]))
                                        }), 128))
                                      ], 2))
                                    : (
                    column.key === 'actionable_column' &&
                      column.showButton(item, index)
                  )
                                      ? (_openBlock(), _createBlock("div", {
                                          key: 7,
                                          class: 
                    `flex gap-x-3 ${column.styleCustom || 'items-center'}`
                  
                                        }, [
                                          (_ctx.groupAction || !!column?.onClickValue)
                                            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                                _createVNode("div", _hoisted_38, [
                                                  _createVNode("div", _hoisted_39, [
                                                    (!!column?.render)
                                                      ? _withDirectives((_openBlock(), _createBlock("div", {
                                                          key: 0,
                                                          onClick: 
                            (event) => {
                              column?.onClickValueCell?.(item, index);
                              event.stopPropagation();
                            }
                          
                                                        }, null, 8, ["onClick"])), [
                                                          [_directive_sanitize_html, column?.render(item)]
                                                        ])
                                                      : _createCommentVNode("", true),
                                                    (!!column?.customValue)
                                                      ? _withDirectives((_openBlock(), _createBlock("div", {
                                                          key: 1,
                                                          onClick: 
                            (event) => {
                              column?.clickCustomValue &&
                                column?.clickCustomValue(item, index);
                              event.stopPropagation();
                            }
                          
                                                        }, null, 8, ["onClick"])), [
                                                          [_directive_sanitize_html, column?.customValue(item)]
                                                        ])
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (column.validateIcon ? column.showIcon(item, index) : true)
                                                    ? _withDirectives((_openBlock(), _createBlock("div", {
                                                        key: 0,
                                                        onClick: 
                          (event) => {
                            if (!_ctx.isDisableClickValue(column, item, index)) {
                              if (!!column?.onClickValue) {
                                column?.onClickValue(item, index);
                              } else {
                                _ctx.toggleMultiple(event, index, column?.columnKey);
                              }
                            }
                            event.stopPropagation();
                          }
                        ,
                                                        class: 
                          _ctx.isDisableClickValue(column, item, index)
                            ? 'cursor-not-allowed'
                            : ''
                        
                                                      }, [
                                                        (_ctx.iconName || column.icon)
                                                          ? _withDirectives((_openBlock(), _createBlock("div", {
                                                              key: 0,
                                                              class: [column.iconStyle || 'py-[1px]']
                                                            }, [
                                                              _createVNode(_component_Icons, {
                                                                id: column?.generateId ? column?.generateId(item, index) : '',
                                                                name: column.icon || _ctx.iconName,
                                                                class: 
                              `w-5 text-${
                                _ctx.isDisableClickValue(column, item, index)
                                  ? 'gray-lp-600'
                                  : column.iconColor || _ctx.iconColor
                              }`
                            
                                                              }, null, 8, ["id", "name", "class"])
                                                            ], 2)), [
                                                              [
                                                                _directive_tooltip,
                                                                
                            column.iconTooltip ? column.iconTooltip(item) : ''
                          ,
                                                                void 0,
                                                                { bottom: true }
                                                              ]
                                                            ])
                                                          : (_openBlock(), _createBlock("button", _hoisted_40, [
                                                              _createVNode("div", {
                                                                class: 
                              `py-1 px-4 bg-white rounded border ${_ctx.borderRowColor ||
                                'border-gray-lp-400'} text-gray-lp-600`
                            ,
                                                                style: {"box-shadow":"0 0 2px 0.5px #e0e0e0"}
                                                              }, [
                                                                _hoisted_41
                                                              ], 2)
                                                            ]))
                                                      ], 10, ["onClick"])), [
                                                        [
                                                          _directive_tooltip,
                                                          
                          column.vtooltip ? column.vtooltip(item) : ''
                        ,
                                                          void 0,
                                                          { bottom: true }
                                                        ]
                                                      ])
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createVNode(_component_OverlayPanel, {
                                                  ref: `op${index}`,
                                                  appendTo: "body",
                                                  style: {"width":"auto"}
                                                }, {
                                                  default: _withId(() => [
                                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupOptions(item, _ctx.columnKey), (option) => {
                                                      return (_openBlock(), _createBlock(_Fragment, {
                                                        key: option.label
                                                      }, [
                                                        _createVNode(_component_LpButton, {
                                                          onClick: 
                            (event) => {
                              option.clickFunction(item, index);
                              _ctx.$refs[`op${index}`]?.hide();
                            }
                          ,
                                                          class: "w-52",
                                                          flat: "",
                                                          dense: "",
                                                          iconLeft: option.icon,
                                                          title: option.label
                                                        }, null, 8, ["onClick", "iconLeft", "title"]),
                                                        (index < _ctx.groupOptions(item).length - 1)
                                                          ? (_openBlock(), _createBlock("hr", _hoisted_42))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1536)
                                              ], 64))
                                            : _createCommentVNode("", true),
                                          (
                      _ctx.deleteAction || _ctx.renderedList[index]['customDeleteAction']
                    )
                                            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                                _createVNode(_component_lp_button, {
                                                  class: "w-6",
                                                  icon: "trash-red",
                                                  onMouseenter: _ctx.toggleTooltip,
                                                  onMouseleave: _ctx.toggleTooltip,
                                                  flat: "",
                                                  dense: "",
                                                  onClick: 
                        (event) => {
                          _ctx.$emit('delete-item', item);
                          event.stopPropagation();
                        }
                      
                                                }, null, 8, ["onMouseenter", "onMouseleave", "onClick"]),
                                                _createVNode(_component_OverlayPanel, {
                                                  ref: "deleteOp",
                                                  appendTo: "body",
                                                  style: {"width":"auto"}
                                                }, {
                                                  default: _withId(() => [
                                                    _createVNode("div", _hoisted_43, _toDisplayString(_ctx.deleteTooltip), 1)
                                                  ]),
                                                  _: 1
                                                }, 512)
                                              ], 64))
                                            : _createCommentVNode("", true),
                                          (_ctx.customButtonAction)
                                            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                                (_ctx.dynamicCustomButtonAction)
                                                  ? (_openBlock(), _createBlock(_component_lp_button, _mergeProps({ key: 0 }, !!column.render && column.render(item), {
                                                      onClick: 
                        (event) => {
                          _ctx.customButtonAction.clickFunction(item, index);
                          event.stopPropagation();
                        }
                      
                                                    }), null, 16, ["onClick"]))
                                                  : (_openBlock(), _createBlock(_component_lp_button, _mergeProps({ key: 1 }, _ctx.customButtonAction, {
                                                      onClick: 
                        (event) => {
                          _ctx.customButtonAction.clickFunction(item, index);
                          event.stopPropagation();
                        }
                      
                                                    }), null, 16, ["onClick"]))
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ], 2))
                                      : (
                    column.key === 'actionable_column' &&
                      !column.showButton(item)
                  )
                                        ? (_openBlock(), _createBlock("div", _hoisted_44, " - "))
                                        : (column.key === 'button_column')
                                          ? (_openBlock(), _createBlock(_Fragment, { key: 9 }, [
                                              (column.styleButton(item, index)?.chip)
                                                ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_45, null, 512)), [
                                                    [_directive_sanitize_html, column.styleButton(item, index).chip]
                                                  ])
                                                : (column.styleButton(item, index))
                                                  ? (_openBlock(), _createBlock("div", _hoisted_46, [
                                                      _createVNode(_component_lp_button, _mergeProps(column.styleButton(item, index), {
                                                        onClick: 
                        (event) => {
                          column
                            .styleButton(item, index)
                            .clickFunction(item, index);
                          column.styleButton(item, index).groupOptions &&
                            _ctx.toggleButtonColumn(event, index, column?.name);
                          event.stopPropagation();
                        }
                      ,
                                                        onMouseenter: ($event: any) => (
                        column.styleButton(item, index).toolTip &&
                          _ctx.toggleTooltipButtonColumn($event, index)
                      ),
                                                        onMouseleave: ($event: any) => (
                        column.styleButton(item, index).toolTip &&
                          _ctx.toggleTooltipButtonColumn($event, index)
                      )
                                                      }), null, 16, ["onClick", "onMouseenter", "onMouseleave"]),
                                                      (!!column.styleButton(item, index).render)
                                                        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_47, null, 512)), [
                                                            [_directive_sanitize_html, 
                        column.styleButton(item, index).render(item)
                      ]
                                                          ])
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                              (column.styleButton(item, index)?.toolTip)
                                                ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                                    key: 2,
                                                    ref: `opBtnColumn${index}`,
                                                    appendTo: "body",
                                                    style: {"width":"auto"}
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode("div", _hoisted_48, _toDisplayString(column.styleButton(item, index).toolTip), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1536))
                                                : _createCommentVNode("", true),
                                              (column.styleButton(item, index)?.groupOptions)
                                                ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                                    key: 3,
                                                    ref: `op${index}${column.name}`,
                                                    appendTo: "body",
                                                    class: 
                      column.styleButton(item, index).groupOptionsClass || ''
                    
                                                  }, {
                                                    default: _withId(() => [
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(column.styleButton(
                        item,
                        index
                      ).groupOptions, (option, groupIndex) => {
                                                        return (_openBlock(), _createBlock(_Fragment, {
                                                          key: option.label
                                                        }, [
                                                          _createVNode(_component_LpButton, {
                                                            onClick: 
                          (event) => {
                            option.clickFunction(item, index);
                            _ctx.$refs[`op${index}${column.name}`]?.hide();
                          }
                        ,
                                                            class: option.customClass || 'w-auto',
                                                            flat: "",
                                                            dense: "",
                                                            iconLeft: option.icon,
                                                            title: option.label,
                                                            iconV2: option.iconV2,
                                                            iconV2Fill: option.iconV2Fill,
                                                            iconColor: option.iconColor,
                                                            textColor: option.textColor,
                                                            sizeIcon: option.sizeIcon,
                                                            iconGroupHoverColor: option.textColor
                                                          }, null, 8, ["onClick", "class", "iconLeft", "title", "iconV2", "iconV2Fill", "iconColor", "textColor", "sizeIcon", "iconGroupHoverColor"]),
                                                          (
                          groupIndex <
                            column.styleButton(item, index).groupOptions
                              .length -
                              1
                        )
                                                            ? (_openBlock(), _createBlock("hr", _hoisted_49))
                                                            : _createCommentVNode("", true)
                                                        ], 64))
                                                      }), 128))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["class"]))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : (column.key === 'double_button_column')
                                            ? (_openBlock(), _createBlock(_Fragment, { key: 10 }, [
                                                (column.styleButton(item, index).chip)
                                                  ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_50, null, 512)), [
                                                      [_directive_sanitize_html, column.styleButton(item, index).chip]
                                                    ])
                                                  : (column.styleButton(item, index))
                                                    ? (_openBlock(), _createBlock("div", {
                                                        key: 1,
                                                        class: 
                      column.styleButtonTwo(item, index)
                        ? 'flex justify-between gap-x-2 items-center'
                        : ''
                    
                                                      }, [
                                                        _createVNode(_component_lp_button, _mergeProps(column.styleButton(item, index), {
                                                          class: 
                        column.styleButtonTwo(item, index) ? 'flex-grow-0' : ''
                      ,
                                                          onClick: 
                        (event) => {
                          column
                            .styleButton(item, index)
                            .clickFunction(item, index);
                          column.styleButton(item, index).groupOptions &&
                            _ctx.toggleMultiple(event, index);
                          event.stopPropagation();
                        }
                      ,
                                                          onMouseenter: ($event: any) => (
                        column.styleButton(item, index).toolTip &&
                          _ctx.toggleTooltipButtonColumn($event, index)
                      ),
                                                          onMouseleave: ($event: any) => (
                        column.styleButton(item, index).toolTip &&
                          _ctx.toggleTooltipButtonColumn($event, index)
                      )
                                                        }), null, 16, ["class", "onClick", "onMouseenter", "onMouseleave"]),
                                                        (column.styleButtonTwo(item, index))
                                                          ? (_openBlock(), _createBlock(_component_lp_button, _mergeProps({ key: 0 }, column.styleButtonTwo(item, index), {
                                                              class: 
                        column.styleButtonTwo(item, index) ? 'flex-grow-0' : ''
                      ,
                                                              onClick: 
                        (event) => {
                          column
                            .styleButtonTwo(item, index)
                            .clickFunction(item, index);
                          column.styleButtonTwo(item, index).groupOptions &&
                            _ctx.toggleMultiple(event, index);
                          event.stopPropagation();
                        }
                      ,
                                                              onMouseenter: ($event: any) => (
                        column.styleButtonTwo(item, index).toolTip &&
                          _ctx.toggleTooltipButtonTwoColumn($event, index)
                      ),
                                                              onMouseleave: ($event: any) => (
                        column.styleButtonTwo(item, index).toolTip &&
                          _ctx.toggleTooltipButtonTwoColumn($event, index)
                      ),
                                                              sizeIcon: column.styleButtonTwo(item, index).sizeIcon
                                                            }), null, 16, ["class", "onClick", "onMouseenter", "onMouseleave", "sizeIcon"]))
                                                          : _createCommentVNode("", true),
                                                        (!!column.styleButton(item, index).render)
                                                          ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_51, null, 512)), [
                                                              [_directive_sanitize_html, 
                        column.styleButton(item, index).render(item)
                      ]
                                                            ])
                                                          : _createCommentVNode("", true)
                                                      ], 2))
                                                    : _createCommentVNode("", true),
                                                (column.styleButton(item, index).toolTip)
                                                  ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                                      key: 2,
                                                      ref: `opBtnColumn${index}`,
                                                      appendTo: "body",
                                                      style: {"width":"auto"}
                                                    }, {
                                                      default: _withId(() => [
                                                        _createVNode("div", _hoisted_52, _toDisplayString(column.styleButton(item, index).toolTip), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1536))
                                                  : _createCommentVNode("", true),
                                                (column.styleButtonTwo(item, index).toolTip)
                                                  ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                                      key: 3,
                                                      ref: `opBtnTwoColumn${index}`,
                                                      appendTo: "body",
                                                      style: {
                      width: 'auto',
                      backgroundColor: column.styleButtonTwo(item, index)
                        .toolTipBackground,
                      color: column.styleButtonTwo(item, index).toolTipTextColor
                    }
                                                    }, {
                                                      default: _withId(() => [
                                                        _createVNode("div", _hoisted_53, _toDisplayString(column.styleButtonTwo(item, index).toolTip), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["style"]))
                                                  : _createCommentVNode("", true),
                                                (column.styleButton(item, index).groupOptions)
                                                  ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                                      key: 4,
                                                      ref: `op${index}`,
                                                      appendTo: "body",
                                                      class: 
                      column.styleButton(item, index).groupOptionsClass || ''
                    
                                                    }, {
                                                      default: _withId(() => [
                                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(column.styleButton(
                        item,
                        index
                      ).groupOptions, (option, groupIndex) => {
                                                          return (_openBlock(), _createBlock(_Fragment, {
                                                            key: option.label
                                                          }, [
                                                            _createVNode(_component_LpButton, {
                                                              onClick: 
                          (event) => {
                            option.clickFunction(item, index);
                            _ctx.$refs[`op${index}`]?.hide();
                          }
                        ,
                                                              class: option.customClass || 'w-auto',
                                                              flat: "",
                                                              dense: "",
                                                              iconLeft: option.icon,
                                                              title: option.label,
                                                              iconV2: option.iconV2,
                                                              iconV2Fill: option.iconV2Fill,
                                                              iconColor: option.iconColor,
                                                              textColor: option.textColor
                                                            }, null, 8, ["onClick", "class", "iconLeft", "title", "iconV2", "iconV2Fill", "iconColor", "textColor"]),
                                                            (
                          groupIndex <
                            column.styleButton(item, index).groupOptions
                              .length -
                              1
                        )
                                                              ? (_openBlock(), _createBlock("hr", _hoisted_54))
                                                              : _createCommentVNode("", true)
                                                          ], 64))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true),
                                                (column.styleButtonTwo(item, index).groupOptions)
                                                  ? (_openBlock(), _createBlock(_component_OverlayPanel, {
                                                      key: 5,
                                                      ref: `op${index}`,
                                                      appendTo: "body",
                                                      class: 
                      column.styleButtonTwo(item, index).groupOptionsClass || ''
                    
                                                    }, {
                                                      default: _withId(() => [
                                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(column.styleButtonTwo(
                        item,
                        index
                      ).groupOptions, (option, groupIndex) => {
                                                          return (_openBlock(), _createBlock(_Fragment, {
                                                            key: option.label
                                                          }, [
                                                            _createVNode(_component_LpButton, {
                                                              onClick: 
                          (event) => {
                            option.clickFunction(item, index);
                            _ctx.$refs[`op${index}`]?.hide();
                          }
                        ,
                                                              class: option.customClass || 'w-auto',
                                                              flat: "",
                                                              dense: "",
                                                              iconLeft: option.icon,
                                                              title: option.label,
                                                              iconV2: option.iconV2,
                                                              iconV2Fill: option.iconV2Fill,
                                                              iconColor: option.iconColor,
                                                              textColor: option.textColor
                                                            }, null, 8, ["onClick", "class", "iconLeft", "title", "iconV2", "iconV2Fill", "iconColor", "textColor"]),
                                                            (
                          groupIndex <
                            column.styleButtonTwo(item, index).groupOptions
                              .length -
                              1
                        )
                                                              ? (_openBlock(), _createBlock("hr", _hoisted_55))
                                                              : _createCommentVNode("", true)
                                                          ], 64))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["class"]))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                            : _createCommentVNode("", true),
                          (column.promoLabel && item.isPromo)
                            ? (_openBlock(), _createBlock("div", _hoisted_56, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(column.promoLabel(item)?.promos, (promo, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: index,
                                    class: "flex"
                                  }, [
                                    _createVNode("div", {
                                      class: "flex flex-row items-center bg-green-lp-700 text-white text-10px px-1 rounded-md mb-1",
                                      onMouseenter: ($event: any) => (_ctx.onOpenTooltipPromo($event, promo.id)),
                                      onMouseleave: ($event: any) => (_ctx.onOpenTooltipPromo($event, promo.id))
                                    }, [
                                      _createVNode("p", null, _toDisplayString(promo.amount), 1),
                                      _createVNode(_component_Icons, {
                                        name: "info",
                                        class: "w-3 ml-1"
                                      })
                                    ], 40, ["onMouseenter", "onMouseleave"]),
                                    (
                        index !== column.promoLabel(item)?.promos.length - 1 &&
                          column.promoLabel(item)?.promos.length > 1
                      )
                                      ? (_openBlock(), _createBlock("span", _hoisted_57, "+"))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_OverlayPanel, {
                                      ref: `infoPromo${promo.id}`,
                                      appendTo: "body",
                                      class: "text-center",
                                      style: {"width":"200px"}
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("p", _hoisted_58, _toDisplayString(promo.desc), 1)
                                      ]),
                                      _: 2
                                    }, 1536)
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 6))
                      }), 128))
                    ], 42, ["onClick", "onMouseenter", "onMouseleave"]),
                    (item.expand)
                      ? (_openBlock(), _createBlock("tr", _hoisted_59, [
                          _createVNode("td", {
                            colspan: _ctx.columns.length,
                            class: "z-0"
                          }, [
                            _renderSlot(_ctx.$slots, "expand-row", {
                              item: item,
                              index: index
                            }, undefined, true)
                          ], 8, ["colspan"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (_ctx.infiniteScroll && _ctx.data)
                  ? (_openBlock(), _createBlock("tr", _hoisted_60, [
                      _hoisted_61
                    ]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, _ctx.loadingMainTable]
              ]),
              _withDirectives(_createVNode("tbody", null, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(5, (index) => {
                  return _createVNode("tr", {
                    key: index,
                    class: "cursor-wait"
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns.length, (indexColumn) => {
                      return (_openBlock(), _createBlock("td", {
                        key: indexColumn,
                        class: 
                `px-4 py-6 xl:py-6 text-12px xxl:text-14px border-b ${_ctx.borderRowColor ||
                  'border-gray-lp-400'}`
              
                      }, [
                        _createVNode(_component_Skeleton, { height: "1.3rem" })
                      ], 2))
                    }), 128))
                  ])
                }), 64))
              ], 512), [
                [_vShow, _ctx.loading]
              ])
            ], 6)
          ], 38)
        ], 2)),
    (
      _ctx.showRightShadow && !_ctx.isWFull && !_ctx.errorCause && !_ctx.renderedList.length === 0
    )
      ? (_openBlock(), _createBlock("div", {
          key: 3,
          class: "table-freeze-zero-shadow",
          style: `height: calc(100% - ${_ctx.shadowYStart}px); top: ${_ctx.shadowYStart}px;`
        }, null, 4))
      : _createCommentVNode("", true),
    (
      !_ctx.loading &&
        _ctx.data.length &&
        !_ctx.hidePagination &&
        !_ctx.errorCause &&
        _ctx.isShowPagination
    )
      ? (_openBlock(), _createBlock("div", {
          key: 4,
          class: _ctx.customClassPagination
        }, [
          (_ctx.paginationStyle === 'v1')
            ? (_openBlock(), _createBlock(_component_Pagination, {
                key: 0,
                onNext: _ctx.nextPage,
                onPrevious: _ctx.prevPage,
                page: _ctx.pagination.page,
                isButtonNext: _ctx.renderedList.length >= _ctx.pagination.limit,
                totalData: _ctx.renderedList.length,
                toPage: _ctx.toPage,
                isShowCaption: _ctx.isShowCaptionPagination,
                paginationWidth: _ctx.paginationWidth,
                "pagination-style": _ctx.paginationStyle,
                isThereIsBottonWidget: _ctx.isThereIsBottonWidget
              }, null, 8, ["onNext", "onPrevious", "page", "isButtonNext", "totalData", "toPage", "isShowCaption", "paginationWidth", "pagination-style", "isThereIsBottonWidget"]))
            : (_ctx.paginationStyle === 'v2' && _ctx.filteredDataBySearch.length > 0)
              ? (_openBlock(), _createBlock(_component_Pagination, {
                  key: 1,
                  onNext: _ctx.nextPage,
                  onPrevious: _ctx.prevPage,
                  page: _ctx.pagination.page,
                  totalData: _ctx.filteredDataBySearch.length,
                  first: _ctx.firstOfTable,
                  last: _ctx.lastOfTable,
                  availablePage: _ctx.availablePage,
                  toPage: _ctx.toDirectPage,
                  paginationWidth: _ctx.paginationWidth,
                  "pagination-style": _ctx.paginationStyle
                }, null, 8, ["onNext", "onPrevious", "page", "totalData", "first", "last", "availablePage", "toPage", "paginationWidth", "pagination-style"]))
              : (_ctx.paginationStyle === 'v3' && _ctx.filteredDataBySearch.length > 0)
                ? (_openBlock(), _createBlock(_component_PaginationV3, {
                    key: 2,
                    pagination: _ctx.pagination,
                    "onUpdate:pagination": _cache[10] || (_cache[10] = ($event: any) => (_ctx.pagination = $event)),
                    onSetPage: _ctx.toPageV3,
                    renderedData: _ctx.data.length,
                    paginationWidth: _ctx.paginationWidth,
                    paginationPaddingVertical: _ctx.paginationV3PaddingVertical,
                    showingLabel: _ctx.paginationV3ShowingLabel,
                    dataLabel: _ctx.paginationV3DataLabel
                  }, null, 8, ["pagination", "onSetPage", "renderedData", "paginationWidth", "paginationPaddingVertical", "showingLabel", "dataLabel"]))
                : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
})